<script setup lang="ts">
import { VIcons } from '@/shared/ui'
import { useEventsNotification } from './../model/model'

const model = useEventsNotification()
</script>

<template>
  <a href="#" class="event-last__btn" @click.prevent="model.openModal">
    <span class="event-last__chip" v-if="model.isNew"></span>

    <VIcons type="notifications" />
  </a>
</template>
